import { Row, RowProps } from 'antd';
import React from 'react';
import styled from 'styled-components';

export const WidgetRowWrapper = styled(Row)``;

export interface IWidgetRowProps extends RowProps {
  children?: React.ReactNode;
}

/**
 * Elemento Riga che applica gli spazi tra i widget.
 */
export function WidgetRow(props: IWidgetRowProps) {
  const { children, ...othersProps } = props;

  return (
    <WidgetRowWrapper gutter={[24, 12]} {...othersProps}>
      {children}
    </WidgetRowWrapper>
  );
}
